import { jsx as _jsx } from "react/jsx-runtime";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { DatePickerStyles } from "./DatePicker.styles";
export var DatePicker = function (props) {
    var sx = DatePickerStyles();
    var value = props.value, onChange = props.onChange, _a = props.disablePast, disablePast = _a === void 0 ? true : _a, error = props.error;
    var handleChange = function (date) {
        // MUI reports a cleared field as null, and an invalid Dayjs while a section is being
        // edited; neither is a date the form should hold, and `undefined` is what `required` catches.
        onChange(date == null || !date.isValid() ? undefined : date.format());
    };
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(MuiDatePicker
        // null, not undefined: MUI fixes controlled-ness on the first render, and an
        // undefined value after a clear would flip the picker to uncontrolled.
        , { 
            // null, not undefined: MUI fixes controlled-ness on the first render, and an
            // undefined value after a clear would flip the picker to uncontrolled.
            value: value ? dayjs(value) : null, onChange: handleChange, sx: sx.wrapper(error), disablePast: disablePast, format: "DD/MM/YYYY" }) }));
};
